import React from 'react';
import { Redirect } from 'react-router-dom';
import { PropTypes } from 'prop-types';

import './landing.css';
import SignIn from '../../containers/Inputs/SignIn';

import Logo from './SolvanaLogo';

const Landing = (props) => {
    const { authToken } = props;
    if (authToken) return <Redirect to="/customers" />;

    return (
        <div className="bg">
            <div className="hero-text">
                <Logo />
                <SignIn />
            </div>
        </div>
    );
};

Landing.propTypes = {
    authToken: PropTypes.string.isRequired,
};

export default Landing;



// WEBPACK FOOTER //
// ./src/containers/Landing/Landing.js